<template>
  <el-dialog
    title="审单"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="visible"
    width="860px"
    append-to-body=""
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :rules="rules"
      label-width="100px"
      :model="orderInfo">
      <el-form-item label="订单号:"> {{ orderInfo.code }} </el-form-item>
      <el-form-item
        required=""
        label="订单标记:"
        prop="orderFlag">
        <el-radio-group v-model="orderInfo.orderFlag">
          <el-radio-button :label="1">正常</el-radio-button>
          <el-radio-button :label="2">拍A发B</el-radio-button>
          <el-radio-button :label="3">刷单</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="出库方式:"
        prop="outType">
        <el-radio-group
          v-model="orderInfo.outType"
          :disabled="outTypeDisabled">
          <el-radio-button :label="1">正常出库</el-radio-button>
          <el-radio-button :label="2">空包</el-radio-button>
          <!-- <el-radio-button :label="3">特殊</el-radio-button> -->
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="发货仓库:"
        prop="warehouseNo">
        <el-input
          v-model="orderInfo.warehouseName"
          readonly="">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="selectWarehouse"></el-button>
        </el-input>
      </el-form-item>
      <el-form-item
        label="物流方式:"
        prop="transType">
        <el-radio-group v-model="orderInfo.transType">
          <el-radio-button :label="1">陆运</el-radio-button>
          <el-radio-button :label="2">空运</el-radio-button>
          <el-radio-button :label="3">自提</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <template v-if="orderInfo.transType !== 3">
        <el-form-item
          label="物流模板:"
          prop="logisticsCode">
          <ent-logistics-select
            ref="logistics"
            v-model="orderInfo.logisticsCode"
            :callback="logisticsSelectCallback"
            :option="{vendorId: userInfo.orgId}" />
        </el-form-item>
        <el-form-item>
          <div slot="label">
            <el-tooltip
              effect="dark"
              content="根据物流模板信息获取">
              <i class="el-icon-question"></i>
            </el-tooltip>
            <span>发件人:</span>
          </div>
          {{ orderInfo.senderName }}-{{ orderInfo.senderMobile }}-{{ orderInfo.senderProvince }}{{ orderInfo.senderCity }}{{ orderInfo.senderDistrict }}{{ orderInfo.senderStreetName }}{{ orderInfo.senderAddress }}
        </el-form-item>
      </template>
      <el-form-item
        v-if="orderInfo.customerName"
        label="客户姓名:"
        prop="customerName">
        {{ orderInfo.customerName }}
      </el-form-item>
      <el-form-item
        v-if="orderInfo.source !==9"
        prop="saleUserIds"
        label="销售人员:">
        <department-staff-select
          v-if="visible"
          v-model="orderInfo.saleUserIds" />
      </el-form-item>
      <el-form-item
        v-else
        label="销售人员:">
        {{ orderInfo.saleDepartmentName }}-{{ orderInfo.saleStaffName }}
      </el-form-item>
      <el-form-item
        label="收件人姓名:"
        prop="receiverName">
        <el-input v-model="orderInfo.receiverName"></el-input>
      </el-form-item>
      <el-form-item
        label="收件人手机:"
        prop="receiverMobile">
        <el-input v-model="orderInfo.receiverMobile"></el-input>
      </el-form-item>
      <el-form-item
        label="收件人电话:"
        prop="receiverTel">
        <el-input v-model="orderInfo.receiverTel"></el-input>
      </el-form-item>
      <el-form-item
        :required="orderInfo.transType !== 3"
        style="margin-bottom:0"
        label="收件省市区:">
        <el-row :gutter="0">
          <el-col :span="7">
            <el-form-item
              label-width="0"
              prop="receiverProvince">
              <el-input v-model="orderInfo.receiverProvince"></el-input>
            </el-form-item>
          </el-col>
          <el-col
            :span="7"
            :offset="1">
            <el-form-item
              label-width="0"
              prop="receiverCity">
              <el-input v-model="orderInfo.receiverCity"></el-input>
            </el-form-item>
          </el-col>
          <el-col
            :span="7"
            :offset="1">
            <el-form-item
              label-width="0"
              prop="receiverDistrict">
              <el-input v-model="orderInfo.receiverDistrict"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item
        label="收件地址:"
        prop="receiverAddress">
        <el-input v-model="orderInfo.receiverAddress"></el-input>
      </el-form-item>
      <el-form-item
        label="备注:"
        prop="remark">
        <el-input
          v-model="orderInfo.remark"
          type="textarea"
          autosize></el-input>
      </el-form-item>
      <el-form-item
        v-loading="orderInfo.outType === 2"
        class="loading-wrap"
        element-loading-text="空包"
        element-loading-spinner="el"
        element-loading-background="rgba(255, 255, 255, 0.7)"
        label="订单明细:"
        prop="detailList">
        <el-button
          v-if="detailListEnabled"
          type="primary"
          style="margin-bottom:10px"
          :loading="loading"
          @click="addProduct">选择商品</el-button>
        <el-table
          v-loading="loading"
          max-height="400px"
          :data="orderInfo.detailList"
          border>
          <el-table-column
            :resizable="false"
            label="商品名称"
            prop="skuName">
            <template slot-scope="{row}">
              {{ row.skuName || row.productName }}
              <el-tag v-if="row.isFree === 1">赠</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            :resizable="false"
            label="商品编码"
            width="80"
            prop="skuCode"></el-table-column>
          <el-table-column
            label="下单数量"
            width="180"
            :resizable="false"
            prop="num">
            <template slot-scope="{row,$index}">
              <el-form-item
                v-if="detailListEnabled"
                label-width="0"
                :prop="'detailList.' + $index + '.num'"
                :rules="[{required: true, message: '请输入下单数量', trigger: 'blur'}]">
                <el-popover
                  placement="top"
                  title="库存"
                  trigger="hover">
                  <div style="font-size: 12px;">
                    <div v-if=" row.warehouse.warehouseNo">仓库：{{ row.warehouse.warehouseNo | warehouseName() }}</div>
                    <div v-else>仓库：未指定</div>
                    <div>库存：{{ row.warehouse.num }}</div>
                  </div>
                  <div
                    slot="reference"
                    class="tttttttttt">
                    <el-input-number
                      v-model="orderInfo.detailList[$index].num"
                      style="width: 80%"
                      :precision="0"
                      :min="1"></el-input-number> {{ row.measureUnit | measureUnitName() }}
                  </div>
                </el-popover>
              </el-form-item>
              <el-popover
                v-else
                placement="top"
                title="库存"
                trigger="hover">
                <div style="font-size: 12px;">
                  <div>仓库：{{ row.warehouse.warehouseNo | warehouseName() }}</div>
                  <div>库存：{{ row.warehouse.num }}</div>
                </div>
                <span slot="reference"> {{ row.num }}  {{ row.measureUnit | measureUnitName() }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            label="零售价"
            :resizable="false"
            prop="retailPrice">
            <template slot-scope="{ $index }">
              <el-form-item
                label-width="0"
                :prop="'detailList.' + $index + '.retailPrice'"
                :rules="[{required: true, message: '请输入零售价', trigger: 'blur'}]">
                <el-input-number
                  v-model="orderInfo.detailList[$index].retailPrice"
                  style="width: 100%"
                  :precision="2"
                  :min="0"></el-input-number>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            label="成交价"
            :resizable="false"
            prop="actualPrice">
            <template slot-scope="{ $index}">
              <el-form-item
                label-width="0"
                :prop="'detailList.' + $index + '.actualPrice'"
                :rules="[{required: true, message: '请输入成交价', trigger: 'blur'}]">
                <el-input-number
                  v-model="orderInfo.detailList[$index].actualPrice"
                  style="width: 100%"
                  :precision="2"
                  :min="0"></el-input-number>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="toggleModal(false)">取 消</el-button>
      <el-button
        :loading="loading"
        type="primary"
        @click="add">确 定</el-button>
    </div>
    <warehouse-select-modal
      ref="warehouse"
      :callback="warehouseCallback" />
    <product-select-modal
      ref="modal"
      :option="{vendorId: userInfo.orgId}"
      @update:list="updateProductItems" />
    <product-muti-select-modal
      ref="muti"
      :callback="updateProductItems" />
  </el-dialog>
</template>
<script>
import WarehouseSelectModal from './warehouse-select-modal.vue'
import EntLogisticsSelect from '../../../components/business/ent-logistics-select.vue'
import ProductSelectModal from './product-select-new-modal.vue'
import NP from 'number-precision'
import { mapState } from 'vuex'
import _ from 'lodash'
import DepartmentStaffSelect from '../../../components/department-staff-select.vue'
import ProductMutiSelectModal from '../../../components/product-muti-select-modal.vue'

export default {
  name: 'OrderAuditModal',
  components: { WarehouseSelectModal, EntLogisticsSelect, ProductSelectModal, DepartmentStaffSelect, ProductMutiSelectModal },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      salesOrderId: null,
      outTypeDisabled: false,
      orderInfo: {
        orderFlag: 1,
        outType: 1,
        warehouseNo: null,
        transType: 1,
        saleUserIds: null,
        logisticsCode: null,
        receiverName: null,
        receiverMobile: null,
        receiverTel: null,
        receiverProvince: null,
        receiverCity: null,
        receiverDistrict: null,
        receiverAddress: null,
        detailList: []
      },
      visible: false
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      warehouse: state => state.account.warehouse
    }),
    rules() {
      const { receiverMobile, receiverTel, transType } = this.orderInfo
      return {
        outType: [{ required: true, message: '请选择订单标记', trigger: 'change' }],
        warehouseNo: [{ required: true, message: '请选择发货仓库', trigger: 'change' }],
        logisticsCode: [{ required: true, message: '请选择物流公司', trigger: 'change' }],
        receiverName: [{ required: true, message: '请输入收件人姓名', trigger: 'blur' }],
        receiverMobile: [{ required: transType !== 3 && (!receiverMobile && !receiverTel), message: '收件人手机/电话至少填写一个', trigger: 'blur' }],
        receiverTel: [{ required: transType !== 3 && (!receiverMobile && !receiverTel), message: '收件人手机/电话至少填写一个', trigger: 'blur' }],
        receiverProvince: [{ required: transType !== 3, message: '请输入收件省份', trigger: 'blur' }],
        receiverCity: [{ required: transType !== 3, message: '请输入收件城市', trigger: 'blur' }],
        receiverDistrict: [{ required: transType !== 3, message: '请输入收件区县', trigger: 'blur' }],
        receiverAddress: [{ required: transType !== 3, message: '请输入收件地址', trigger: 'blur' }],
        saleUserIds: [{ required: true, message: '请输入销售人员', trigger: 'blur' }],
        detailList: [{ type: 'array', required: true, message: '请选择订单明细', trigger: 'change' }]
      }
    },
    detailListEnabled() {
      return [1, 2, 3, 4, 5, 6, 8].indexOf(this.orderInfo.source) > -1
    }
  },
  watch: {
    'orderInfo.transType'(val) {
      if (val === 3) {
        this.orderInfo.logisticsCode = null
        this.logisticsSelectCallback({})
      }
    },
    'orderInfo.orderFlag': {
      handler(val) {
        if (val === 1 || val === 2) {
          this.orderInfo.outType = 1
          this.outTypeDisabled = true
        }
        if (val === 3) {
          this.outTypeDisabled = false
        }
      },
      immediate: true
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.orderInfo = {
        orderFlag: 1,
        outType: 1,
        warehouseNo: null,
        transType: 1,
        saleUserIds: null,
        logisticsCode: null,
        receiverName: null,
        receiverMobile: null,
        receiverTel: null,
        receiverProvince: null,
        receiverCity: null,
        receiverDistrict: null,
        receiverAddress: null,
        detailList: []
      }
      this.salesOrderId = null
      this.outTypeDisabled = false
    },
    logisticsSelectCallback(row) {
      console.log(row, 'logisticsCode')
      this.orderInfo.senderName = row.senderName
      this.orderInfo.senderProvince = row.senderProvinceName
      this.orderInfo.senderCity = row.senderCityName
      this.orderInfo.senderDistrict = row.senderAreaName
      this.orderInfo.senderAddress = row.senderAddress
      this.orderInfo.senderMobile = row.senderPhone
      this.orderInfo.senderStreetName = row.senderStreetName
      localStorage.setItem('sh_default_logistics', JSON.stringify({
        logisticsCode: row.expressId,
        senderName: row.senderName,
        senderProvince: row.senderProvinceName,
        senderCity: row.senderCityName,
        senderDistrict: row.senderAreaName,
        senderAddress: row.senderAddress,
        senderMobile: row.senderPhone,
        senderStreetName: row.senderStreetName
      }))
    },
    add() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          const info = this.orderInfo.transType !== 3 ? this.$refs.logistics.info : {}
          const { senderName = '无', senderPhone = '无', senderProvinceName = '无', senderCityName = '无', senderAreaName = '无', senderAddress = '无', senderStreetName = '无' } = info
          const saleUserIds = this.orderInfo.saleUserIds || []
          this.$store.dispatch('outstock/salesouttypeaudit', {
            payload: {
              ...this.orderInfo,
              outType: +this.orderInfo.outType,
              logisticsCode: this.orderInfo.logisticsCode || '00',
              salesOrderDetailAdjustItemList: this.orderInfo.detailList.map(i => {
                return {
                  ...i,
                  skuName: i.skuName || i.productName,
                  saleOrderDetailId: i.id,
                  actualPrice: NP.times(i.actualPrice, 100),
                  retailPrice: NP.times(i.retailPrice, 100)
                }
              }),
              salesOrderId: this.orderInfo.id,
              senderName,
              senderMobile: senderPhone,
              senderProvince: senderProvinceName,
              senderCity: senderCityName,
              senderDistrict: senderAreaName,
              senderStreet: senderStreetName,
              senderAddress,
              saleDepartmentNumber: saleUserIds[0] || null,
              saleStaffNumber: saleUserIds[1] || null
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    selectWarehouse() {
      this.$refs.warehouse.fetch({
        departmentId: this.orderInfo.ownerCode
      })
    },
    warehouseCallback(row) {
      this.orderInfo.warehouseNo = row.warehouseNo
      this.orderInfo.warehouseName = row.warehouseName
      localStorage.setItem('sh_default_warehouse', row.warehouseNo)
      this.getstocklist(this.orderInfo.warehouseNo, this.orderInfo.detailList.map(i => i.skuId))
    },
    addProduct() {
      // this.$refs.modal.fetch(this.orderInfo.detailList)
      const ids = this.orderInfo.detailList.map(i => i.skuId)
      this.$refs.muti.fetch(ids)
    },
    updateProductItems(rows) {
      const detailList = this.orderInfo.detailList
      const result = []
      rows.forEach(i => {
        const item = detailList.find(s => s.skuId === i.productId)
        if (item) {
          result.push(item)
        } else {
          result.push({
            skuName: i.productName,
            skuId: i.productId,
            skuCode: i.productNumber,
            outNum: 0,
            num: 1,
            retailPrice: 0,
            actualPrice: 0,
            warehouse: { skuId: i.productId, id: null, num: 0 }
          })
        }
      })
      this.$set(this.orderInfo, 'detailList', result)
      if (this.orderInfo.warehouseNo) {
        this.getstocklist(this.orderInfo.warehouseNo, this.orderInfo.detailList.map(i => i.skuId))
      }
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('outstock/salesdetail', {
        payload: {
          salesOrderId: this.salesOrderId
        },
        success: res => {
          this.loading = false
          res.data.data.detailList.forEach(i => {
            i.warehouse = { skuId: i.skuId, id: null, num: 0 }
          })
          const warehouseNo = res.data.data.warehouseNo || localStorage.getItem('sh_default_warehouse')
          let logistics = JSON.parse(localStorage.getItem('sh_default_logistics') || '{}')
          const logisticsCode = res.data.data.logisticsCode ? +res.data.data.logisticsCode : null
          logistics = logisticsCode ? {} : logistics
          const warehouseName = (this.warehouse.find(i => i.warehouseNo === warehouseNo) || {}).warehouseName
          this.$set(this, 'orderInfo', {
            ...this.orderInfo,
            ...res.data.data,
            outType: res.data.data.outType || 1,
            saleUserIds: res.data.data.saleDepartmentNumber && res.data.data.saleStaffNumber ? [res.data.data.saleDepartmentNumber, res.data.data.saleStaffNumber] : null,
            saleStaffName: res.data.data.saleStaffName,
            saleDepartmentName: res.data.data.saleDepartmentName,
            logisticsCode: logisticsCode,
            ...logistics,
            orderFlag: +res.data.data.orderFlag || 1,
            warehouseName: warehouseName,
            warehouseNo: warehouseName ? warehouseNo : null,
            detailList: res.data.data.detailList.map(s => {
              return {
                ...s,
                actualPrice: NP.divide(s.actualPrice, 100),
                retailPrice: NP.divide(s.retailPrice, 100)
              }
            })
          })
          if (res.data.data.warehouseNo) {
            this.getstocklist(this.orderInfo.warehouseNo, this.orderInfo.detailList.map(i => i.skuId))
          }
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getstocklist(warehouseNo, skuIdList) {
      this.$store.dispatch('outstock/stocklist', {
        payload: {
          pageNum: 1,
          pageSize: 1000,
          warehouseNo,
          skuIdList
        },
        success: (res) => {
          console.log(res)
          const records = res.data.data.records
          this.loading = false
          const detailList = _.cloneDeep(this.orderInfo.detailList)
          detailList.forEach(i => {
            const item = records.find(s => s.skuId === i.skuId) || { skuId: i.skuId, warehouseNo, id: null, num: 0 }
            i.warehouse = item
          })
          this.$set(this.orderInfo, 'detailList', detailList)
        },
        fail: () => {
          this.loading = false
          const records = []
          const detailList = _.cloneDeep(this.orderInfo.detailList)
          detailList.forEach(i => {
            const item = records.find(s => s.skuId === i.skuId) || { skuId: i.skuId, warehouseNo, id: null, num: 0 }
            i.warehouse = item
          })
          this.$set(this.orderInfo, 'detailList', detailList)
        }
      })
    },
    fetch(salesOrderId) {
      if (this.loading) {
        return
      }
      this.salesOrderId = salesOrderId
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
<style lang="stylus">
.loading-wrap {
  .el-loading-text {
    font-size: 20px;
    color: #333
  }
}
</style>
